// extracted by mini-css-extract-plugin
module.exports = {"playIcon":"style__playIcon__0MGcs"};